import React from 'react';
import { installExecutionApi } from '../services/api';
import { InstallPhaseWorkspace, InstallPhaseConfig } from './InstallPrepTask';

const INSTALL_EXECUTION_CONFIG: InstallPhaseConfig = {
  phase: 'EXECUTION',
  api: installExecutionApi,
  copy: {
    caseLabel: 'Installation Execution',
    totalTimeLabel: 'Total install time (hours)',
    headerStatus: {
      IN_PROGRESS: 'In progress',
      ON_HOLD: 'On hold',
      COMPLETED: 'Ready for verification'
    },
    statusButtonLabels: {
      IN_PROGRESS: 'In progress',
      ON_HOLD: 'On hold',
      COMPLETED: 'Installed'
    },
    summaryPlaceholder: 'Generate a summary of onsite installation (IQ/OQ) work for the verification team.',
    summaryGenerateLabel: 'Generate install summary',
    summaryGeneratingLabel: 'Generating...',
    summaryEditLabel: 'Edit summary',
    summaryNoDataLabel: 'No installation summary yet.',
    runNotesLabel: 'Installation notes',
    markCompleteButtonLabel: 'Mark ready for verification',
    loadingMessage: 'Loading installation workspace...',
    loadError: 'Failed to load installation task',
    saveError: 'Failed to save installation task'
  },
  preInstallCheck: {
    title: 'Pre-install handoff',
    description: 'Reference from site readiness to show what was complete before IQ/OQ begins.',
    badgeLabels: {
      COMPLETE: 'Complete',
      NOT_REQUIRED: 'Not required',
      INCOMPLETE: 'Incomplete',
      INCOMPLETE_WITH_REASON: 'Incomplete with note',
      PARTIAL: 'Partially complete',
      UNKNOWN: 'Pending'
    },
    outstandingTitle: 'Outstanding pre-install items',
    noteLabel: 'Technician note',
    actionLabel: 'Open pre-install workspace',
    actionPath: 'pre'
  },
  enforceLayout: 'site',
  disableStepNotes: true
};

const InstallExecutionTask: React.FC = () => {
  return <InstallPhaseWorkspace config={INSTALL_EXECUTION_CONFIG} />;
};

export default InstallExecutionTask;
